import { Loader, Modal, ShareModalProps } from "ui";

import {
  useFeedInsertsSettings,
  useUpdateFeedInsertsSettings
} from "../../../apis";
import { FeedInsertSettings } from "../../../content.types";
import { FeedInsertsSettingsForm } from "../../forms";

import styles from "./FeedInsertsSettingsModal.module.scss";

const FEED_INSERT_FORM_ID = "feed-insert-form";

const FeedInsertsSettingsModal = ({ isOpen, onClose }: ShareModalProps) => {
  const { feedInsertsSettings, isLoading } = useFeedInsertsSettings();
  const updateFeedInsertsSettings = useUpdateFeedInsertsSettings({
    onSuccess: () => {
      onClose();
    }
  });

  const handleFormSubmit = (formData: FeedInsertSettings) => {
    updateFeedInsertsSettings.mutate({
      showInsertsAfterSpecifiedNumberOfProducts: Number(
        formData.showInsertsAfterSpecifiedNumberOfProducts
      )
    });
  };

  return (
    <Modal
      formId={FEED_INSERT_FORM_ID}
      isOpen={isOpen}
      title="Inserts Position Settings"
      isLoading={false}
      okText="Save"
      className={styles.modal}
      onClose={onClose}
    >
      <>
        {isLoading && <Loader />}
        {feedInsertsSettings && (
          <FeedInsertsSettingsForm
            formId={FEED_INSERT_FORM_ID}
            defaultValues={feedInsertsSettings}
            onSubmit={handleFormSubmit}
          />
        )}
      </>
    </Modal>
  );
};

export default FeedInsertsSettingsModal;
